/**
 * PATH: packages/ui/src/kanban/components/lane/LaneCardsSkeleton.tsx
 * FILE_ID: UI-KANBAN-LANE-CARDS-SKEL-001
 * PURPOSE: In-lane shimmer placeholders while a lane's cards query is
 *          still pending and has no data yet.
 * WHY: Reuses KanbanSkeleton's card visual language so progressive
 *      per-lane loading does not look like an empty/stuck board.
 */
export interface LaneCardsSkeletonProps {
  /** How many fake cards to draw. Default 4. */
  cardCount?: number
  animate?: boolean
}

export function LaneCardsSkeleton({
  cardCount = 4,
  animate = true,
}: LaneCardsSkeletonProps) {
  const shimmer = animate ? 'animate-pulse' : ''
  return (
    <div
      data-testid="lane-cards-skeleton"
      data-kanban-lane-cards-skeleton=""
      className="flex flex-1 flex-col gap-1.5 p-0"
      aria-hidden="true"
    >
      {Array.from({ length: cardCount }).map((_, ci) => (
        <div
          key={ci}
          className={`h-16 shrink-0 rounded-lg border border-neutral-200/60 bg-white dark:border-zinc-700/60 dark:bg-zinc-800 ${shimmer}`}
          style={{ animationDelay: `${ci * 60}ms` }}
        />
      ))}
    </div>
  )
}
